import { createSVGElement } from '@/utils/svg-kit';
import type { BoundingBox } from '@/version-types';
import type { TextRenderInput } from '../types';

/**
 * 将普通文字背景绘制到 surface 提供的背景挂载点。
 *
 * @param target - surface 中位于其他视觉内容下方的背景挂载点。
 * @param input - 当前 Text Render 输入。
 * @param layoutBox - 背景覆盖的完整逻辑区域。
 * @returns void，通过副作用追加可见背景矩形。
 */
export const drawBackground = (target: SVGElement, input: TextRenderInput, layoutBox: BoundingBox): void => {
    const background = input.backgrounds?.find((item) => !item.hidden);
    if (!background || layoutBox.width <= 0 || layoutBox.height <= 0) return;

    const maxRadius = Math.ceil(Math.min(layoutBox.width, layoutBox.height) / 2);
    const radius = Math.min(Math.max(0, background.roundWeight ?? 0), maxRadius);

    const rect = createSVGElement('rect', {
        'data-bg-rect': '',
        x: layoutBox.left,
        y: layoutBox.top,
        width: layoutBox.width,
        height: layoutBox.height,
        rx: radius,
        ry: radius,
        fill: background.color,
    });

    target.appendChild(rect);
};
